export default function getProjectId(): string | undefined {
  return getProjectIdIfPresent() || undefined;
}

export function getProjectIdIfPresent(): string | undefined {
  const { pathname } = window.location;

  if (!pathname.startsWith('/projects/')) {
    return undefined;
  }

  return pathname.split('/')[2];
}
